<template>
   <div>

    <portal to="nav-bar">
      <button @click="$emit('close', !upHere)" class="icon-button clip-l silver pa3">
        <font-awesome-icon icon="filter" />
      </button>
    </portal>

    <div class="content-container">
      <div class="content center">
        <slot name="content"></slot>
      </div>
      <div class="sidebar dn db-l">
        <div class="sidebar-content">
          <slot name="sidebar"></slot>
        </div>
      </div>
    </div>

    <mobile-modal :show="upHere" @close="$emit('close', false)">
      <slot name="mobile-sidebar"></slot>
    </mobile-modal>

  </div>
</template>

<script>
import MobileModal from '@/components/modal/MobileModal.vue'

export default {
  components: {
    MobileModal
  },
  model: {
    prop: 'upHere',
    event: 'close'
  },
  props: {
    upHere: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
.content-container {
  display: grid;
  grid-template-columns: 100vw;
  grid-template-rows: auto;
  grid-template-areas:
    "content"
}
.content {
  grid-column: content;
  width: 100%;
}
.sidebar {
  grid-column: sidebar;
}
.sidebar-content {
  position: fixed;
  width: 300px;
  height: calc(100% - 60px);
  overflow-y:scroll;
  padding-right: 1rem;
  padding-left: 0.5rem;
}
@media screen and (min-width: 60em) {
  .content-container {
    display: grid;
    grid-template-columns: auto 300px;
    grid-template-rows: auto;
    grid-template-areas:
      "content sidebar"
  }
}
</style>
